module.exports = __webpack_public_path__ + "assets/alarm.f8aab8bc.svg";